module.exports = __webpack_public_path__ + "static/media/loading.3ee2dbef.gif";